// Same trigger/panel/checkmark interaction as <sort-popover> (sort-popover.js),
// reused for the cart quantity dropdown. Only difference: cart.js's CartItems
// listens for 'change' on quantity controls (not 'input', which sort-popover
// dispatches for the facets filter pipeline), so this subclass dispatches
// 'change' instead when an option is picked.
class QuantitySelectPopover extends SortPopover {
  onOptionClick(event) {
    const option = event.currentTarget;
    const value = option.dataset.value;

    if (this.select.value !== value) {
      this.select.value = value;
      this.select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    this.label.textContent = option.querySelector('.sort-popover__option-label').textContent.trim();

    this.panel.querySelectorAll('.sort-popover__option').forEach((otherOption) => {
      const isActive = otherOption === option;
      otherOption.classList.toggle('sort-popover__option--active', isActive);
      otherOption.setAttribute('aria-selected', isActive);
    });

    this.close();
  }
}

customElements.define('quantity-select-popover', QuantitySelectPopover);
